// ❌ NotFound - Page 404 pour les URLs invalides
// Page d'erreur personnalisée avec thème rock et suggestions de navigation
// Utilisé dans : src/App.jsx (routes "*" et "/404")

import { Link } from 'react-router-dom'
import { Home, Music, ArrowLeft } from 'lucide-react'
import pagesData from '@/locales/pages.json'
import uiData from '@/locales/ui.json'
import globalData from '@/locales/global.json'

/**
 * Page 404 personnalisée pour Rock'In Agde
 * Design thématique avec citation rock, navigation suggérée
 * Textes chargés depuis pages.json pour faciliter la personnalisation
 */
export default function NotFound() {
  const { notFound } = pagesData
  const { common } = uiData
  const { navigation } = globalData
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 via-neutral-950 to-black text-white flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 animé */}
        <div className="mb-8 relative">
          <h1 className="text-9xl md:text-[12rem] font-display font-bold text-primary-500/20 select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <Music className="w-24 h-24 md:w-32 md:h-32 text-primary-500 animate-pulse" />
          </div>
        </div>

        {/* Message */}
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-4">
          {notFound.title}
        </h2>
        <p className="text-xl md:text-2xl text-neutral-300 mb-2">
          {notFound.subtitle}
        </p>
        <p className="text-lg text-neutral-400 mb-8">
          {notFound.description}
        </p>

        {/* Citations rock */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 mb-8 max-w-lg mx-auto">
          <p className="text-neutral-300 italic">
            "{notFound.quote.text}"
          </p>
          <p className="text-sm text-neutral-500 mt-2">
            – {notFound.quote.author}
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all shadow-xl hover:shadow-primary-500/50 hover:scale-105"
          >
            <Home size={24} />
            {common.buttons.backToHome}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border-2 border-white/30 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all"
          >
            <ArrowLeft size={24} />
            {common.buttons.previousPage}
          </button>
        </div>

        {/* Suggestions */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-neutral-400 mb-4">{notFound.suggestions.title}</p>
          <div className="flex flex-wrap justify-center gap-3">
            {navigation.desktop.slice(1).map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className="px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg text-sm text-neutral-300 hover:text-white transition"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
